import React, { Fragment, useState } from "react"
import { connect } from "react-redux";
import { translate } from "react-i18next";
import { compose } from "redux";
import EnhancedModal from "../../enhanced-modal"
import { Button, Col, Form, Icon, Row, Tooltip } from "antd"
import { GUTTER_MD, MARGIN_MD, MODAL_WIDTH_LG, MODAL_WIDTH_SM, SPAN_FULL } from "../../../styles/constants";
import Selector from "../../selector";
import ItemList from "../../item-list";
import { DataLanguageConsumer } from "../../../contexts/DataLanguage";
import { getArtefactTripletFromUrn } from "../../../utils/sdmxJson";
import {
  hideAnnotationsFormDefaultFiltersSelector,
  readAnnotationsFormDataflowBuilderDefaultFiltersItems,
  readAnnotationsFormDefaultFiltersItems,
  showAnnotationsFormDefaultFiltersSelector
} from "./actions";
import _ from "lodash";

const mapStateToProps = state => ({
  appLanguage: state.app.language,
  selectedDimension: state.scenes.commons.defaultFilterModal.selectedDimensionForDefaultFilterItemsSelector,
  itemsPage: state.scenes.commons.defaultFilterModal.itemsPageForDefaultFilterItemsSelector,
  itemsCount: state.scenes.commons.defaultFilterModal.itemsCountForDefaultFilterItemsSelector
});

const mapDispatchToProps = dispatch => ({
  onShowSelector: (codelistTriplet, item) => dispatch(showAnnotationsFormDefaultFiltersSelector(codelistTriplet, item)),
  onHideSelector: () => dispatch(hideAnnotationsFormDefaultFiltersSelector()),
  fetchItemsPage: ({
    codelistTriplet,
    language,
    pageNum,
    pageSize,
    searchText,
    filters,
    sortCol,
    sortByDesc
  }) => dispatch(readAnnotationsFormDefaultFiltersItems({
    codelistTriplet,
    language,
    pageNum,
    pageSize,
    searchText,
    filters,
    sortCol,
    sortByDesc
  })),
  fetchDataflowBuilderItemsPage: ({
    codelistTriplet,
    language,
    pageNum,
    pageSize,
    searchText,
    filters,
    sortCol,
    sortByDesc
  },
    cubeId,
    colNames,
    colName,
    filterStr
  ) => dispatch(readAnnotationsFormDataflowBuilderDefaultFiltersItems({
    codelistTriplet,
    language,
    pageNum,
    pageSize,
    searchText,
    filters,
    sortCol,
    sortByDesc
  },
    cubeId,
    colNames,
    colName,
    filterStr))
});

const DefaultFiltersModal = ({
  t,
  filter,
  dsdDimensions,
  appLanguage,
  itemsPage,
  itemsCount,
  fetchItemsPage,
  onShowSelector,
  onHideSelector,
  onChange,
  filterDefaultValues,
  disabled,
  fetchDataflowBuilderItemsPage,
  cubeId,
  dataflowColumns,
  dataflowFilterStr
}) => {
  const [selectedDimension, setSelectedDimension] = useState(null)
  const [isSelectorVisible, setSelectorVisible] = useState(false)

  const filtersWithCodelist = filter.filter(id => (dsdDimensions || []).find(dim => dim.id === id && dim.representation))

  const TIME_PERIOD_KEY = "TIME_PERIOD";


  const getCodelistTriplet = (filterItem) => {
    const dimension = dsdDimensions.find((element) => (element.id === filterItem))
    return dimension.representation ?
      getArtefactTripletFromUrn(dimension.representation) : null;
  }
  const onSelectItem = (selectedValue) => {
    if (selectedDimension) {
      const newFilterDefaultValues = _.cloneDeep(filterDefaultValues)
      newFilterDefaultValues[selectedDimension.filterDimension] = selectedValue
      onChange(newFilterDefaultValues);
      onHideSelector()
      setSelectedDimension(null)
    }

  }
  const onResetItem = (dimension) => {
    const { [dimension]: _, ...newFilterDefaultValues } = filterDefaultValues
    onChange(newFilterDefaultValues)
  }
  return (
    <Fragment>
      {/* Default filter primary modal */}
      <EnhancedModal
        visible={isSelectorVisible}
        width={MODAL_WIDTH_SM}
        title={
          <Row gutter={GUTTER_MD} type={'flex'}>
            <Col>
              <span>
                {t('components.annotationsForm.defaultFiltersModal.mainModal.title')}
              </span>
            </Col>
            <Col>
              <Tooltip overlayStyle={{ whiteSpace: 'pre-line' }} title={t('components.annotationsForm.defaultFiltersModal.mainModal.warning')}>
                <Icon className='warningTooltip' type="info-circle" theme="outlined" style={{ color: 'grey' }} />
              </Tooltip>
            </Col>
          </Row>
        }
        onCancel={() => setSelectorVisible(false)}
        footer={
          <Button
            onClick={() => { setSelectorVisible(false) }}
          >
            {t('commons.buttons.close.title')}
          </Button>
        }
      >
        <Form className="advanced-form">
          {filtersWithCodelist.filter(e => e !== TIME_PERIOD_KEY).map((dimension, i) => {
            return (
              <Row key={i} gutter={GUTTER_MD} style={{ marginBottom: MARGIN_MD }}>
                <Col span={SPAN_FULL}>
                  <Form.Item
                    label={dimension}
                  >
                    <Selector
                      selectTitle={t('components.annotationsForm.defaultFiltersModal.selectIcon.title')}
                      resetTitle={t('components.annotationsForm.defaultFiltersModal.resetIcon.title')}
                      onSelect={() => {
                        onShowSelector()
                        setSelectedDimension({ codelistTriplet: getCodelistTriplet(dimension), filterDimension: dimension })
                      }}
                      onReset={() => onResetItem(dimension)}
                      value={filterDefaultValues[dimension] || null}
                      disabled={disabled}
                    />
                  </Form.Item>
                </Col>
              </Row>)
          })}
        </Form>
      </EnhancedModal>

      {/* Selector modal */}
      <EnhancedModal
        visible={!!selectedDimension}
        width={MODAL_WIDTH_LG}
        title={t('components.annotationsForm.defaultFiltersModal.selectorModal.title')}
        onCancel={() => {
          onHideSelector()
          setSelectedDimension(null)
        }}
        footer={
          <div>
            <Button onClick={() => {
              onHideSelector()
              setSelectedDimension(null)
            }}>
              {t('commons.buttons.cancel.title')}
            </Button>

          </div>
        }
        withDataLanguageSelector
      >
        {selectedDimension && selectedDimension.codelistTriplet !== null && (
          <DataLanguageConsumer>
            {dataLanguage => {
              const language = dataLanguage || appLanguage;
              return (
                <ItemList
                  data={itemsPage || null}
                  rowCount={itemsCount}
                  isPaginated
                  onChange={
                    cubeId ?
                      (({ pageNum, pageSize, searchText, filters, sortCol, sortByDesc }) => {
                        fetchDataflowBuilderItemsPage({
                          codelistTriplet: selectedDimension.codelistTriplet,
                          language,
                          pageNum,
                          pageSize,
                          searchText,
                          filters,
                          sortCol,
                          sortByDesc
                        },
                          cubeId,
                          dataflowColumns,
                          "ID_" + selectedDimension.filterDimension,
                          dataflowFilterStr
                        )
                      }) :
                      (({ pageNum, pageSize, searchText, filters, sortCol, sortByDesc }) =>
                        fetchItemsPage({
                          codelistTriplet: selectedDimension.codelistTriplet,
                          language,
                          pageNum,
                          pageSize,
                          searchText,
                          filters,
                          sortCol,
                          sortByDesc
                        }))

                  }
                  onRowClick={item => onSelectItem(item.id)}

                />
              );
            }}
          </DataLanguageConsumer>
        )}

      </EnhancedModal>

      <Button
        onClick={() => setSelectorVisible(true)}
        disabled={(filtersWithCodelist || []).length === 0}
      >
        {t('components.annotationsForm.defaultFiltersModal.button.title')}
      </Button>
    </Fragment>
  )

}
export default compose(
  translate(),
  connect(mapStateToProps, mapDispatchToProps)
)(DefaultFiltersModal)